import gql from 'graphql-tag';

import { EnterpriseConfigurationCourseMetadataFragment } from 'bundles/enterprise-legacy-learner-home/constants/ProgramCommonGraphqlQueries';

export const AdminCollectionItemBodyCourseRowFragment = gql`
  fragment AdminCollectionItemBodyCourseRowFragment on CoursesV1 {
    id
    slug
    name
    logo: photoUrl
    upcomingSessionStartDate
    workload
    courseTypeMetadata {
      id
      courseTypeMetadata {
        __typename
      }
    }
    partners {
      elements {
        id
        name
        squareLogo
      }
    }
  }
`;
export const CurriculumSummariesDataLoaderQuery = gql`
  query CurriculumSummariesDataLoaderQuery($programId: String!) {
    EnterpriseProgramCurriculumSummariesV2Resource {
      get(id: $programId) {
        id
        courseSummaries
      }
    }
  }
`;

/**
 * Query to bulk fetch associated private session details for curriculum items.
 */
export const PrivateSessionCurriculumSummariesDataLoaderQuery = gql`
  query PrivateSessionCurriculumSummariesDataLoaderQuery($sessionIds: [String!]!, $limit: Int) {
    OnDemandCourseSessionsV1Resource {
      multiGet(ids: $sessionIds, limit: $limit) {
        elements {
          id
          startsAt
          endsAt
        }
      }
    }
  }
`;

export const CatalogCollectionItemBodyS12nRowFragment = gql`
  fragment CatalogCollectionItemBodyS12nRowFragment on OnDemandSpecializationsV1 {
    id
    name
    logo
    partners {
      elements {
        id
        name
        squareLogo
        productBrandingLogo
      }
    }
    courseIds
    productVariant
    courses {
      elements {
        id
        name
        logo: photoUrl
        upcomingSessionStartDate
        workload
      }
    }
  }
`;

export const autoEnrollmentQuery = gql`
  query AdminAutoEnrollmentQuery($programId: String!) {
    ProgramEnrollmentSettingsV1Resource {
      byTargetProgram(programId: $programId) {
        elements {
          id
          enrollmentTargetCourse {
            id
          }
          triggerEventJoinedProgram {
            id
          }
        }
      }
    }
  }
`;

export const CollectionTableMetadataQuery = gql`
  query CollectionTableMetadataQuery($configScopeIds: [String!]!, $limit: Int) {
    EnterpriseProductConfigurationMetadataV1Resource {
      multiGet(ids: $configScopeIds, limit: $limit) {
        elements {
          ...EnterpriseConfigurationMetadataFragment
        }
      }
    }
  }
  ${EnterpriseConfigurationCourseMetadataFragment}
`;
